import { Component } from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntity, BaseState, Log, LogParams } from '@m4u-angular/base/entities/BaseEntities';
import { LogEndpoint } from '@core/endpoints/log.endpoint';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { EnumLogLevel } from '@m4u-angular/core/framework/sysenums.enum';
import { Utils } from '@m4u-angular/core/helpers/Utils';

class State extends BaseState {
    ObjectType: string;
    ObjectID: number;
    Level: EnumLogLevel;
    Body: string;

    ObjectTypes: string[];
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-logs',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.scss']
})
export class LogsComponent extends BasePageComponent<BaseEntity, State> {

    constructor(A: ServiceBagService,
        private logEndpoint: LogEndpoint) {
        super(A, 'LogsComponent', BaseEntity, State);
    }

    protected override OnInitComponent(): void {
        this.State.ObjectType = this.QueryParams.ObjectType;
        if (this.QueryParams.ObjectID) {
            this.State.ObjectID = +this.QueryParams.ObjectID;
        }
        this.NotifyReloadTitle();
        this._initDataSource();
        this._initObjectTypes();
    }

    public override GetTitle(): string {
        let title = this.RC('ttlLogs');

        if (this.State.ObjectType) {
            title = `${title}. ${this.State.ObjectType}`;
        }

        if (this.State.ObjectID) {
            title = `${title} - ${this.State.ObjectID}`;
        }

        return title;
    }

    public onSelectLog(log: Log) {
        this.State.Body = log?.Body;
    }

    public onApply() {
        this._initDataSource();
    }

    private _initDataSource() {
        const params = new LogParams();
        params.RelatedObjectID = !Utils.IsEmpty(this.State.ObjectID) ? +this.State.ObjectID : undefined;
        params.RelatedObjectType = this.State.ObjectType;
        params.Level = this.State.Level ? this.State.Level : EnumLogLevel.Unknown;

        this.DataSources['Logs'] = new DataSourceCustomAction( (options: DataLoadOptions) => 
            this.logEndpoint.ListEx(params, options), undefined, undefined, false);
    }

    private _initObjectTypes() {
        this.Do(this.logEndpoint.GetObjectTypes(), false, (response) => {
            this.State.ObjectTypes = response.Data;
        });
    }

}
